<template>

	<section class="section-content wallet">
    <div class="header height" style="background-color: transparent"></div>
    <b-container class="static mb-4">
    <b-card no-body class="overflow-hidden">
      <b-row no-gutters>
        <b-col lg="3" style="background-color: #fafbff;">
          <div class="p-4">
            <b-form style="border-color: #4A4CB0; color: #ffffff; background-color: #4A4CB0; font-size: 25px; border-radius: calc(6px - 1px)" class="mb-3 text-center" show><b>{{ name }}</b>
            </b-form>
            <vue-qrcode v-if="$store.state.address" class="w-100 mb-4" :width="300" :mask-pattern="7" :margin="0" :color="{dark: '#33262d'}" :value="$store.state.address"/>
            <b-input-group class="mb-3">
              <b-form-input disabled v-model="$store.state.address"/>
              <b-input-group-append>
                <b-button v-clipboard:copy="$store.state.address" v-clipboard:success="onCopy" class="px-3 cursor-pointer" style="border-color: #4A4CB0; background-color: #4A4CB0; color: #ffffff">
                  <i class="fal fa-copy"/>
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <b-list-group flush style="border-radius: 5px">
              <b-list-group-item class="new-col-bg" :to="{ path: '/wallet'}">
                <i class="fal fa-exchange"/> {{ $t('wallet.ln_0') }}
              </b-list-group-item>
              <b-list-group-item class="new-col-bg" :to="{ path: '/wallet/transactions'}">
                <i class="fal fa-history"/> {{ $t('wallet.ln_1') }}
                <b-badge v-if="count" style="font-size: 15px; border-color: transparent; background-color: transparent" class="float-right" variant="light">{{ count }}</b-badge>
              </b-list-group-item>
              <b-list-group-item class="new-col-bg" :to="{ path: '/wallet/tokens'}">
                <i class="fal fa-badge-dollar"/> {{ $t('wallet.ln_30') }}
                <b-badge v-if="counts[0]" style="font-size: 15px; border-color: transparent; background-color: transparent" class="float-right" variant="light">{{ counts[0] }}</b-badge>
              </b-list-group-item>
              <b-list-group-item :active="getActive('/wallet/tokens/main')" class="new-col-bg" :to="{ path: '/wallet/tokens/main'}">
                <i class="fal fa-badge-check"/> {{ $t('wallet.ln_31') }}
                <b-badge v-if="counts[1]" style="font-size: 15px; border-color: transparent; background-color: transparent" class="float-right" variant="light">{{ counts[1] }}</b-badge>
              </b-list-group-item>
              <b-list-group-item class="new-col-bg" :to="{ path: '/wallet/token'}">
                <i class="fal fa-coins"/> {{ $t('wallet.ln_7') }}
              </b-list-group-item>
              <b-list-group-item class="new-col-bg" :to="{ path: '/wallet/setting'}">
                <i class="fal fa-cog"/> {{ $t('wallet.ln_13') }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-col>
        <b-col lg="9">
          <b-card-body>
            <router-view/>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
			<div class="clearfix"></div>
		</b-container>
	</section>
</template>

<script lang="js">

import axios from "axios";
import api from "../../libs/api";
import VueQrcode from 'vue-qrcode';
import VueClipboard from 'vue-clipboard2';
import Vue from "vue";

Vue.use(VueClipboard)

export default {
	name: "wallet.main",
  components: {
    VueQrcode
  },
	data() {
		return {
			counts: [],
			count: 0,
      name: null,
      active: false,
		}
	},

  mounted() {
    axios.post(api.account.info, {address: this.$store.state.address}).then((response) => {
      this.$data.name = response.data.name
    });
  },
	watch: {
		$route() {
			this.getCount();
		}
	},
	created() {
		this.getCount();
	},
	methods: {
		getCount() {
			for (let i = 0; i < 2; i++) {
				axios.post(api.wallet.getTokens, {imprint: true, main: i === 1}).then((response) => {
					this.$data.counts[i] = Number(response.data.count);
				});
			}
			axios.post(api.explorer.getTransactions, {imprint: true, main: true}).then((response) => {
				this.$data.count = Number(response.data.count);
			});
		},

    onCopy() {
      this.$bvToast.toast(`${this.$t('success.ln_5')}`, {
        title: this.$t('success.ln_3'),
        autoHideDelay: 2500,
        toaster: 'b-toaster-bottom-right',
        variant: 'info',
      });
    },

    getActive(name) {
      if (this.$route.name === null) {
        return false
      }
      return this.$route.name.split('.')[0] === name;
    },
	}
}
</script>

<style scoped>


</style>
